import * as React from "react";
import { Component } from "react";
import { Image } from "react-bootstrap";

import tick from "../../../assets/images/tick.svg";

import classes from "./UploadSuccessful.module.css";

interface IParentProps {
  modalClosed: (boolean) => void;
  heading: string;
  subHeading: string;
}
type Props = IParentProps;
class UploadSuccessful extends Component<Props> {
  render() {
    const { modalClosed, heading, subHeading } = { ...this.props };
    return (
      <div onClick={modalClosed}>
        <div className="popupHeader popupHeaderBdr">
          {/* <h6>Upload Successful</h6> */}
          <div className="closeBtn">X</div>
        </div>

        <div className={classes.popupBody}>
          <Image src={tick} alt="checkimage" />
          <h5>{heading}</h5>
          <h6>{subHeading}</h6>
        </div>
      </div>
    );
  }
}
export default UploadSuccessful;
